import classNames from 'classnames';
import * as bd from 'react-basic-design';
import { Link } from 'react-router-dom';
import SvgArrowDownward from '../../../../assets/icons/ArrowDownward';
import SvgArrowLeft from '../../../../assets/icons/ArrowLeft';
import SvgArrowRight from '../../../../assets/icons/ArrowRight';
import SvgArrowUpward from '../../../../assets/icons/ArrowUpward';
import { N } from '../../../../components/basic/n';
import { T } from '../../../../components/basic/text';
import { tileIcons } from './tile-icons';
import { CSSProperties } from 'react';

type SysMenuTileProps = {
    tile: any;
    designMode?: boolean;
    onDesignClick?: (ev: any) => void;
};

export const SysMenuTile = ({ tile, designMode, onDesignClick }: SysMenuTileProps) => {
    var css = classNames('sys-menu-tile', tile.cssClass, {
        'news-feed': tile.isFeed,
        'tile-wide': tile.isWide,
    });

    const icon = (tileIcons as any)[tile.iconCode];
    const getArrow = () => {
        if (tile.indicatorArrow == 'down') return <SvgArrowDownward />;
        if (tile.indicatorArrow == 'up') return <SvgArrowUpward />;
        if (tile.indicatorArrow == 'left') return <SvgArrowLeft />;
        if (tile.indicatorArrow == 'right') return <SvgArrowRight />;
        return null;
    };
    const backgroundImage = !tile.coverImage
        ? undefined
        : tile.coverImage[0] == '/'
          ? `url(${tile.coverImage})`
          : tile.coverImage;

    const opacity = tile.visible ? 1 : 0.25;
    const style: CSSProperties = { backgroundImage, opacity };

    if (tile.isFeed) {
        return (
            <div className={css} style={style}>
                {!designMode && (
                    <a href={tile.url}>
                        <T>{tile.title}</T>
                        <T as="small">{tile.subTitle}</T>
                    </a>
                )}

                {designMode && (
                    <a href={tile.url} onClick={onDesignClick}>
                        <T>{tile.title}</T>
                        <T as="small">{tile.subTitle}</T>
                    </a>
                )}
            </div>
        );
    }

    const parent_style: CSSProperties = { backgroundImage, opacity };
    const indicator_style: CSSProperties = { fontSize: '13px' };
    const padding_style: CSSProperties = { paddingLeft: 10 };
    return (
        <div className={css} style={parent_style}>
            {!designMode && (
                <Link to={tile.visible ? tile.url : '#'}>
                    <T>{tile.title}</T>
                    <T as="small">{tile.subTitle}</T>
                </Link>
            )}

            {designMode && (
                <bd.Button
                    title={tile.visible ? tile.url : '#'}
                    className="h-auto text-start rounded-0"
                    onClick={onDesignClick}
                >
                    <T>{tile.title}</T>
                    <T as="small">{tile.subTitle}</T>
                </bd.Button>
            )}

            <bd.Flex className="flex-grow-1" content="end" vertical style={padding_style}>
                <bd.Flex align="center" gap={2} className="ltr">
                    {icon && <div className={classNames('tile-icon', tile.iconCss)}>{icon}</div>}
                    {tile.indicatorCode && designMode && (
                        <>
                            <div className={classNames('tile-indicator', tile.indicatorCss)}>
                                <N>{1234}</N>
                            </div>
                            <bd.Flex
                                vertical
                                content="end"
                                className={classNames(
                                    'pb-20 align-self-end size-md',
                                    tile.indicatorCss
                                )}
                                style={indicator_style}
                            >
                                {getArrow()}
                                <div>{tile.indicatorUnit}</div>
                            </bd.Flex>
                        </>
                    )}
                    {tile.hasIndicator && (
                        <>
                            <div className={classNames('tile-indicator', tile.indicatorCss)}>
                                {!tile.indicator && (
                                    <div className="m-e-0 spinner-border spinner-border-sm"></div>
                                )}
                                <N>{tile.indicator}</N>
                            </div>
                            <bd.Flex
                                vertical
                                content="end"
                                className={classNames(
                                    'pb-20 align-self-end size-md',
                                    tile.indicatorCss
                                )}
                                style={indicator_style}
                            >
                                {getArrow()}
                                <div>{tile.indicatorUnit}</div>
                            </bd.Flex>
                        </>
                    )}
                </bd.Flex>
                <T className="tile-footer small">{tile.footer}</T>
            </bd.Flex>
        </div>
    );
};
